<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-toolbar class="primary white--text">
          <v-toolbar-title class="headline text-xs-center">
            Order Management
          </v-toolbar-title>
          <v-spacer />
        </v-toolbar>
        <v-card>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-switch
                    v-model="currentSettings.isOrderTime"
                    :label="`${
                        'Show Order Time: ' +
                        (currentSettings.isOrderTime ? 'YES' : 'NO')
                    }`"
                    ></v-switch>
                </v-flex>
                <v-flex xs12 sm6 md6>
                    <v-switch
                    v-model="currentSettings.isStaffSelection"
                    :label="`${
                        'Show Staff Selection: ' +
                        (currentSettings.isStaffSelection ? 'YES' : 'NO')
                    }`"
                    ></v-switch>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              @click="update"
              flat
              v-if="!currentSettings['.key']"
              >Save</v-btn
            >
            <v-btn
              color="blue darken-1"
              @click="update"
              flat
              v-if="!!currentSettings['.key']"
              >Update</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
      <v-snackbar
      v-model="snackbar"
      :timeout="3000"
    >
    Shop Settings updated!
    </v-snackbar>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
export default {
  data() {
    return {
      brandLogo: null,
      snackbar : false,
      currentSettings: {
        isOrderTime : false,
        isStaffSelection : false,
      },
    };
  },
  created() {
    this.$bindAsArray(
      "orderSettings",
      this.$root.$firebaseRefs.orderSetting
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
      this.getCurrentSettings();
  },
  watch: {
    orderSettings: {
      handler(value) {
        this.getCurrentSettings();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand"]),
   
  },
  methods: {
    update() {
      if (this.currentSettings[".key"]) {
        let key = this.currentSettings[".key"];
        delete this.currentSettings[".key"];
        this.$root.$firebaseRefs.orderSetting
          .child(key)
          .set(this.currentSettings)
          .then(() => {
            this.currentSettings[".key"] = key;
            this.snackbar = true;
          });
      } else {
        this.currentSettings.brand = this.selectedBrand;
        let res = this.$root.$firebaseRefs.orderSetting.push(
          this.currentSettings
        );
        this.currentSettings[".key"] = res["key"];
        this.snackbar = true;
      }
    },
    getCurrentSettings() {
      if (this.orderSettings.length) {
        this.currentSettings = this.orderSettings[0];
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Settings/OrderSettings/OrderSettings.vue